export const CornerstoneTools = {
  Wwwc: {
    name: 'Wwwc', icon: 'icon-ww', type: 'basic', string: 'Windowing (W)', save: false, privilege: 'basic'
  },
  WwwcRegion: { //TODO set icon
    name: 'WwwcRegion', icon: 'icon-ww_zone', type: 'basic', string: 'Región de windowing', save: false, privilege: 'basic'
  },
  Zoom: {
    name: 'Zoom', icon: 'icon-zoom', type: 'basic', string: 'Zoom (Z)', save: false, privilege: 'basic'
  },
  Magnify: {
    name: 'Magnify', icon: 'icon-magnify', type: 'basic', string: 'Lente magnificadora', save: false, privilege: 'basic'
  },
  Pan: {
    name: 'Pan', icon: 'icon-pan', type: 'basic', string: 'Mover (M)', save: false, privilege: 'basic'
  },
  //'StackScroll': {
  //  name: 'StackScroll', icon: 'icon-stack_scroll', type: 'basic', string: 'Scroll', save: false, privilege:'basic'
  //},
  Length: {
    name: 'Length', icon: 'icon-length', type: 'annotation', string: 'Distancia', save: true, privilege: 'basic'
  },
  Angle: {
    name: 'Angle', icon: 'icon-angle', type: 'annotation', string: 'Ángulo', save: true, privilege: 'basic'
  },
  Probe: {
    name: 'Probe', icon: 'icon-probe', type: 'annotation', string: 'Pixel', save: true, privilege: 'basic'
  },
  EllipticalRoi: {
    name: 'EllipticalRoi', icon: 'icon-ellipse_measure', type: 'annotation', string: 'Elipse', save: true, privilege: 'basic'
  },
  RectangleRoi: {
    name: 'RectangleRoi', icon: 'icon-rectangle', type: 'annotation', string: 'Rectángulo', save: true, privilege: 'basic'
  },
  FreehandRoi: { //TODO set icon
    name: 'FreehandRoi', icon: 'icon-polygon_measure', type: 'annotation', string: 'Polígono', save: true, privilege: 'basic'
  },
  CobbAngle: { //TODO set icon
    name: 'CobbAngle', icon: 'icon-cobb_angle', type: 'annotation', string: 'Ángulo de Cobb', save: true, privilege: 'full'
  },
  Rotate: {
    name: 'Rotate', icon: 'icon-rotate', type: 'basic', string: 'Rotar (R)', save: false, privilege: 'basic'
  },
  ArrowAnnotate: { //TODO set icon
    name: 'ArrowAnnotate', icon: 'icon-arrow_text', type: 'annotation', string: 'Anotación con flecha', save: true, privilege: 'basic'
  },
  TextAnnotate: { //TODO set icon
    name: 'TextAnnotate', icon: 'icon-text', type: 'annotation', string: 'Insertar texto', save: true, privilege: 'basic'
  },
  Bidirectional: { //TODO set icon
    name: 'Bidirectional', icon: 'icon-perpendicular', type: 'annotation', string: 'Perpendiculares', save: true, privilege: 'full'
  },
  Print: {
    name: 'Print', icon: 'icon-print', type: 'none', string: 'Imprimir', save: false, privilege: 'full'
  },
  HLine: { //TODO set icon
    name: 'HLine', icon: 'icon-horizontal_line', type: 'annotation', string: 'Línea horizontal', save: true, privilege: 'basic'
  },
  VLine: { //TODO set icon
    name: 'VLine', icon: 'icon-vertical_line', type: 'annotation', string: 'Línea vertical', save: true, privilege: 'basic'
  },
  Parallel: { //TODO set icon
    name: 'Parallel', icon: 'icon-parallel', type: 'annotation', string: 'Paralelas', save: true, privilege: 'basic'
  },
  Eraser: { //TODO set icon
    name: 'Eraser', icon: 'icon-eraser', type: 'annotation', string: 'Goma de borrar', save: false, privilege: 'basic'
  },
  LineDraw: { //TODO set icon
    name: 'LineDraw', icon: 'icon-minus', type: 'drawing', string: 'Línea', save: true, privilege: 'full'
  },
  FreehandDraw: { //TODO set icon
    name: 'FreehandDraw', icon: 'icon-polygon_draw', type: 'drawing', string: 'Polígono', save: true, privilege: 'full'
  },
  EllipticalDraw: { //TODO set icon
    name: 'EllipticalDraw', icon: 'icon-ellipse_draw', type: 'drawing', string: 'Elipse', save: true, privilege: 'full'
  },
  ScaleOverlay: { //TODO set icon
    name: 'ScaleOverlay', icon: 'block', type: 'none', string: 'Escala', save: false, privilege: 'basic'
  },
  SynchPoint: { //TODO set icon
    name: 'SynchPoint', icon: 'block', type: 'none', string: 'Punto sincronizado', save: false, privilege: 'full'
  },
  Brush: { //TODO set icon
    name: 'Brush', icon: 'icon-brush', type: 'drawing', string: 'Pintar', save: true, privilege: 'basic'
  },
  Cursor: { //TODO set icon
    name: 'Cursor', icon: 'block', type: 'none', string: 'Cursor', save: false, privilege: 'basic'
  },
  MPRReference: { //TODO set icon
    name: 'MPRReference', icon: 'block', type: 'none', string: 'Referencia MPR', save: false, privilege: 'basic'
  },
  ObliqueLine: { //TODO set icon
    name: 'ObliqueLine', icon: 'block', type: 'none', string: 'Oblicua', save: false, privilege: 'basic'
  },

  Placeholder: {
    name: 'Placeholder', icon: 'block', type: 'none', string: 'to do', save: false, privilege: 'basic'
  },
}